import {get } from "@polymer/polymer/lib/utils/path";
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "../../shared/SearchHeader"

import check_description from "images/icons/icon_check_white.svg";

import "./SearchWebinarHeader.style"

class SearchWebinarHeader extends PolymerElement {
    static get template() {
        return html `
        <style include="search-webinar-header-style"></style>
        <div class="search-webinar-header">
          <div class="search-webinar-container">
          <p class="category-page">Beranda / Webinar</p>
          <h1>Tanya Jawab Langsung dengan Pakar Kedokteran</h1>
          <ul class="description-list">
            <li>
              <img src$="[[iconCheckDescription]]" alt="alomedika"/>
              Materi Studi Terkini
            </li>
            <li>
              <img src$="[[iconCheckDescription]]" alt="alomedika"/>  
              Waktu Fleksibel
            </li>
            <li>
              <img src$="[[iconCheckDescription]]" alt="alomedika"/>  
              SKP Gratis
            </li>
          </ul>
          <search-header><search-header>
        </div>
        </div>
    `;
    }

    static get properties() {
        return {
            iconCheckDescription: {
                type: String,
                value: check_description,
            }
        }
    }
}
customElements.define("search-webinar-header", SearchWebinarHeader);